import React from "react";
import { Form, Input } from "antd";
import { LockOutlined } from "@ant-design/icons";

const UserPinCode = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="pinCode"
      label="Pin Code"
      rules={[
        {
          required: true,
          message: "Please input pin code",
        },
        {
          min: 4,
          message: "Min length must be at least 4 characters",
        },
      ]}
    >
      <Input.Password
        showCount
        maxLength={4}
        minLength={4}
        prefix={<LockOutlined className="form-item-icon" />}
        placeholder="Pin Code"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default UserPinCode;
